import { Box, Container, Divider, Grid, Typography } from '@mui/material';
import React from 'react';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';
import AccountIcon from '@mui/icons-material/AccountCircle';
import TableClientAccounts from './TableClientAccounts';
import { useTranslation } from 'react-i18next';

function LoginAccountClient(props) {
    const location = useLocation();
    const {t} = useTranslation();

    let accounts = [];
    let uid = null;
    let language = "";

    if(location.state && location.state.accounts && location.state.uid){
        accounts = location.state.accounts;
        uid = location.state.uid;
        language = location.state.language
    }
    
    return (
        <>
            <Helmet>
                <title>{t('clientAreaTitle')}</title>
            </Helmet>

            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    height: '100%',
                    justifyContent: 'center'
                }}
            >

                {(accounts.length !== 0 && uid !== null) ?

                    <Container maxWidth="sm" variant='cont-nk' sx={{mt: "3rem"}}>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <Box mt={3} mb={3} >
                                    <Typography variant='h4' sx={{ textAlign: "center" }}>{t('selectAccount')}</Typography>
                                    <Divider />
                                </Box>
                            </Grid>

                            <Grid item xs={12} sx={{ textAlign: "center" }}>
                                <AccountIcon color="primary" sx={{ fontSize: "8rem" }} />
                            </Grid>

                            <Grid item xs={12} >
                                <Typography sx={{ fontSize: "1.33rem", mb:"2rem" }}>{t('selectAccountToManage')} </Typography>

                                <TableClientAccounts accounts = {accounts} uid = {uid} language = {language} />

                            </Grid>

                        </Grid>
                    </Container>

                    :

                    <Container maxWidth="sm" variant='cont-nk'>

                        <Box sx={{ mb: 2, mt: 3 }}>
                            <Typography
                                color="textPrimary"
                                variant="h2"
                                align="center"
                            >
                                {t('sorry')}
                            </Typography>

                        </Box>

                        <Box sx={{ pt: 1, pb: 2 }}>
                            <Typography
                                color="textSecondary"
                                gutterBottom
                                variant="body1"
                                align="center"
                            >
                                {t('optionUnavailable')}
                            </Typography>

                        </Box>

                    </Container>

                }

            </Box>

        </>
    );

}

export default LoginAccountClient;